import React, { useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import { Container } from "@mui/system";
import Page from "../../components/Page";
import Moment from "moment";
import ReportePorDia from "./ReportesPorDia";
//import HeaderReportsDay from "./reportedias/HeaderReportsDay";
import HeaderMenuDates from "./reportedias/HeaderMenuDates";
const ReportexFechas = () => {
  const [datos, setDatos] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [bodyDialog, setBodyDialog] = useState("");
  const [title, setTitle] = useState("");
  return (
    <>
      <Page title="Reportes por fechas">
        <Container>
          <HeaderMenuDates
            setOpenDialog={setOpenDialog}
            setBodyDialog={setBodyDialog}
            setDatos={setDatos}
            setTitle={setTitle}
          />

          <ReportePorDia datos={datos} leyendas={title} />
        </Container>
      </Page>
      <Dialog open={openDialog}>
        <DialogTitle>Selecciona el filtro a aplicar</DialogTitle>
        <DialogContent>{bodyDialog}</DialogContent>
      </Dialog>
    </>
  );
};

export default ReportexFechas;
